import ev from "../util/enumValue";

enum AssetContentMode {

    COVER = ev('COVER', 1),
    CONTAIN = ev('CONTAIN', 2)
}

export default AssetContentMode;
